import { useEffect, useRef, useState } from "react";
import { useMediaQuery } from '@mui/material';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  // removed faCircleChevronLeft / faCircleChevronRight
  faCircle,
  faCaretLeft,
  faCaretRight,
} from "@fortawesome/free-solid-svg-icons";


export default function ImageCarousel({ images = [] }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const containerRef = useRef(null);
  const intervalRef = useRef(null);

  const isDesktop = useMediaQuery('(min-width:1600px)');
  // Auto-advance every 5 seconds
  useEffect(() => {
    startAutoSlide();
    return stopAutoSlide;
  }, [activeIndex]);

  const startAutoSlide = () => {
    stopAutoSlide();
    intervalRef.current = setInterval(() => {
      handleNext();
    }, 5000);
  };

  const stopAutoSlide = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
  };

  const handleNext = () => {
    setActiveIndex((prev) =>
        prev === images.length - 1 ? 0 : prev + 1
    );
    };


  const handlePrev = () => {
    setActiveIndex((prev) =>
        prev === 0 ? images.length - 1 : prev - 1
    );
    };


  // Scroll focused image into view
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const imageEl = container.children[activeIndex];
    if (imageEl && containerRef.current) {
      const container = containerRef.current;

      const containerRect = container.getBoundingClientRect();
      const imageRect = imageEl.getBoundingClientRect();

      const offset =
        imageRect.left -
        containerRect.left -
        container.clientWidth / 2 +
        imageRect.width / 2;

      container.scrollTo({
        left: container.scrollLeft + offset,
        behavior: "smooth",
      });
    }
  }, [activeIndex]);

  // Progress bar fill (red only at end)
  const progress =
    activeIndex === images.length - 1
      ? 100
      : (activeIndex / (images.length - 1)) * 100;

  return (
    <div style={{ width: "100%", color: "white", paddingBottom: "50px"}}>
      {/* Image Row */}
      <div
        ref={containerRef}
        style={{
          display: "flex",
          overflowX: "hidden",
          gap: "15px",
          padding: "20px",
          scrollBehavior: "smooth",
          marginTop: "40px",
          scrollbarWidth: "none",
        }}
      >
        {images.map((img, index) => (
          <div
            key={index}
            style={{
              flex: "0 0 auto",
              transition: "transform 0.3s ease, border 0.3s ease",
              transform:
                index === activeIndex ? "scale(1.2)" : "scale(1)",
              borderRadius: "8px",
              overflowX: "hidden",
              zIndex: index === activeIndex ? 2 : 1,
            }}
          >
            <img
              src={img}
              alt={`carousel-${index}`}
              style={{
                maxHeight: isDesktop ? "310px" : "200px",
                width: "auto",
                borderRadius: "6px",
                display: "block",
              }}
              className="carousel-image"
            />
          </div>
        ))}
      </div>

      {/* Controls */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "0 200px",
          marginTop: "20px",
        }}
        className="progress-div"
      >
        <button
          onClick={handlePrev}
          aria-label="Previous"
          style={{ background: "none", border: "none" }}
        >
          <span style={{ position: "relative", display: "inline-block", width: 48, height: 48 }}>
            <FontAwesomeIcon icon={faCircle} style={{ color: "#FE9A00", fontSize: 40 }} />
            <FontAwesomeIcon
              icon={faCaretLeft}
              style={{
                color: "#ffffff", // chevron color
                position: "absolute",
                left: "50%",
                top: "42%",
                transform: "translate(-50%, -50%)",
                fontSize: 25,
              }}
            />
          </span>
        </button>

        <button
          onClick={handleNext}
          aria-label="Next"
          style={{ background: "none", border: "none" }}
        >
          <span style={{ position: "relative", display: "inline-block", width: 48, height: 48 }}>
            <FontAwesomeIcon icon={faCircle} style={{ color: "#FE9A00", fontSize: 40, }} />
            <FontAwesomeIcon
              icon={faCaretRight}
              style={{
                color: "#ffffff", // chevron color
                position: "absolute",
                left: "50%",
                top: "42%",
                transform: "translate(-50%, -50%)",
                fontSize: 25,
              }}
            />
          </span>
        </button>


        {/* Progress Bar */}
        <div
          style={{
            flex: 1,
            height: "4px",
            backgroundColor: "white",
            borderRadius: "4px",
            overflow: "hidden",
            maxWidth: "400px",
            marginLeft: "20px",
            position: "relative",
            bottom: "3px",
          }}
        >
          <div
            style={{
              height: "100%",
              width: `${progress}%`,
              backgroundColor: "#FE9A00",
              transition: "width 0.4s ease",
            }}
          />
        </div>
      </div>
    </div>
  );
}
